const cleanLevel = value => typeof value === 'string' ? value.trim().toLowerCase() : '';

export function normalizeModelMetadata(payload) {
  const rows = Array.isArray(payload) ? payload : (Array.isArray(payload?.models) ? payload.models : []);

  return rows
    .filter(row => row && typeof row === 'object' && typeof row.model === 'string')
    .map(row => {
      const nestedThinking = row.thinking && typeof row.thinking === 'object' ? row.thinking : {};
      const rawLevels = Array.isArray(row.thinking_levels)
        ? row.thinking_levels
        : (Array.isArray(nestedThinking.levels) ? nestedThinking.levels : []);
      const thinkingLevels = [...new Set(rawLevels.map(cleanLevel).filter(Boolean))];
      const documentedDefault = cleanLevel(
        row.default_thinking_level ?? nestedThinking.default,
      );
      const declaredSupport = row.supports_thinking ?? nestedThinking.supported;
      const supportsThinking = declaredSupport === false
        ? false
        : thinkingLevels.length > 0;

      return {
        ...row,
        thinking_levels: supportsThinking ? thinkingLevels : [],
        default_thinking_level: supportsThinking && thinkingLevels.includes(documentedDefault)
          ? documentedDefault
          : null,
        supports_thinking: supportsThinking,
      };
    });
}

export function findModelMetadata(models, modelId) {
  const rows = Array.isArray(models) ? models : [];
  const requested = typeof modelId === 'string' ? modelId.trim() : '';
  const isDefault = !requested || requested.toLowerCase() === 'default';

  if (isDefault) {
    return rows.find(row => row.model?.toLowerCase() === 'default') || null;
  }

  return rows.find(row => row.model === requested)
    || rows.find(row => row.model?.toLowerCase() === requested.toLowerCase())
    || null;
}

export function getThinkingSelectorConfig(models, modelId, explicitLevel = '') {
  const metadata = findModelMetadata(models, modelId);
  const levels = metadata?.supports_thinking ? metadata.thinking_levels : [];
  const selected = cleanLevel(explicitLevel);
  const value = levels.includes(selected) ? selected : '';

  if (!levels.length) {
    return {
      disabled: true,
      value: '',
      options: [{ value: '', label: 'Thinking unavailable' }],
      metadata,
    };
  }

  const defaultSuffix = metadata.default_thinking_level
    ? ` (${metadata.default_thinking_level})`
    : '';

  return {
    disabled: false,
    value,
    options: [
      { value: '', label: `Provider default${defaultSuffix}` },
      ...levels.map(level => ({ value: level, label: level })),
    ],
    metadata,
  };
}

export function getExplicitThinkingLevel(models, modelId, explicitLevel = '') {
  return getThinkingSelectorConfig(models, modelId, explicitLevel).value || null;
}

export function withExplicitThinkingLevel(payload, models, modelId, explicitLevel = '') {
  const serialized = { ...payload };
  delete serialized.thinking_level;
  const validLevel = getExplicitThinkingLevel(models, modelId, explicitLevel);
  if (validLevel) serialized.thinking_level = validLevel;
  return serialized;
}
